import React, { Component, cloneElement } from 'react';
import echarts from 'echarts';
import pick from 'lodash/pick';
import world from './world.json';
import $ from 'jquery';

echarts.registerMap('world', world);

export default class Chart extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { onReady } = this.props;
    this.drawChart(this.props);
    if (onReady) {
      onReady(this.chart);
    }
  }

  componentWillReceiveProps( nextProps ) {
    this.updateChart(nextProps);
  }

  componentWillUnmount() {
    this.chart.dispose();
  }

  getChartData(options) {
    options.series = [];
    React.Children.map(this.props.children, (child) => {
      options.series.push({...child.props});
    });
  }

  drawChart( props ) {
    const node = this.chartRef;
    const { events, value, type } = props;
    const eventList = events || [];
    let options;
    if (props.options) {
      options = props.options;
    } else {
      options = pick( props, [
        'backgroundColor',
        'animation',
        'calculable',
        'renderAsImage',
        'timeline',
        'title',
        'toolbox',
        'tooltip',
        'legend',
        'dataRange',
        'dataZoom',
        'roamController',
        'grid',
        'color',
        'xAxis',
        'yAxis',
        'series',
      ]);
      this.getChartData(options);
    }
    const chart = echarts.getInstanceByDom(node);
    if (!chart) {
      this.chart = echarts.init(node);
    }
    this.chart.setOption(options, props.theme);
    eventList.map(({ type, handler }) => {
      this.chart.off(type);
      this.chart.on(type, handler);
    });

    this.updateChart(props);

  }

  updateChart(props) {

    const { value, type } = props;

    if(value){
      if(type=='pie'){
        this.chart.dispatchAction({type: 'pieSelect',name: value});
      }
      if(type=='geo'){
        this.chart.dispatchAction({type: 'mapSelect',name: value});
      }
    }
  }

  renderChildren() {
    return React.Children.map(this.props.children, (child) => {
      return cloneElement(child, {
        hasChart: true
      });
    });
  }

  render() {
    const { width, height, style, ...props } = this.props;
    return (
      <div
        className="chart"
        ref={(node)=>{ this.chartRef = node}}
        style={{
          height,
          width,
          ...style,
        }}>
        {this.renderChildren()}
      </div>
    );
  }
}

Chart.propTypes = {
  backgroundColor: React.PropTypes.string,
  animation: React.PropTypes.bool,
  calculable: React.PropTypes.bool,
  renderAsImage: React.PropTypes.bool,
  style: React.PropTypes.object,
  theme: React.PropTypes.object,
  timeline: React.PropTypes.object,
  title: React.PropTypes.object,
  toolbox: React.PropTypes.object,
  tooltip: React.PropTypes.object,
  legend: React.PropTypes.object,
  dataRange: React.PropTypes.object,
  dataZoom: React.PropTypes.object,
  roamController: React.PropTypes.object,
  grid: React.PropTypes.object,
  color: React.PropTypes.array,
  children: React.PropTypes.node,
  xAxis: React.PropTypes.oneOfType([
    React.PropTypes.object,
    React.PropTypes.array,
  ]),
  yAxis: React.PropTypes.oneOfType([
    React.PropTypes.object,
    React.PropTypes.array,
  ]),
  onReady: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/worldmap/Chart.js